<template>
  <div v-if="!ssoFlg" class="p-header-navi-switch-button-for-sp-layout">
    <button
      class="p-header-navi-switch-button-for-sp-layout__button"
      @click="emitClickEvent()"
    >
      <i class="p-header-navi-switch-button-for-sp-layout__button__icon">
        <IconBase
          :width="16"
          :height="16"
          viewBox="0 0 24 24"
          :icon-color="colorCode"
        >
          <IconLoop />
        </IconBase>
      </i>
      <span
        class="p-header-navi-switch-button-for-sp-layout__button__text"
        :style="{ color: colorCode }"
      >
        <slot />
      </span>
    </button>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconLoop from "@/common/components/icons/IconLoop.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import loginInfo from "@/general/store/modules/loginInfo";

@Options({
  props: {
    switchState: { type: Boolean, required: false, default: false }
  },
  components: { IconBase, IconLoop }
})
export default class HeaderNaviSwitchButtonForSpLayout extends Vue {
  switchState!: boolean;
  ssoFlg = false;

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
  }

  emitClickEvent() {
    this.$emit("click-change-modal-state");
  }
}
</script>

<style lang="scss" scoped>
.p-header-navi-switch-button-for-sp-layout {
  &__button {
    display: flex;
    padding: rem(11) rem(12) rem(12);
    margin: 0 0 0 auto;

    &__icon {
      display: block;
      margin-top: rem(1);
      line-height: 1;
    }

    &__text {
      font-size: rem(10);
      font-weight: bold;
      display: block;
    }
  }
}
</style>
